import { render, staticRenderFns } from "./CategoryItemSiblingUSP.vue?vue&type=template&id=9aa0c61c"
import script from "./CategoryItemSiblingUSP.vue?vue&type=script&lang=js"
export * from "./CategoryItemSiblingUSP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports